import React from 'react'
import { Bar, LabelList} from 'recharts';
export default function BarBuilder({choices,prefix,total,colors}) {


    const bars = choices.map((item, index) => {
        const bars = [];
        const itemValue = prefix ? `${prefix}.${item.value}`: item.value;
        bars.push(
        <Bar dataKey={itemValue} name={item.text} fill={colors[index]} isAnimationActive={false} > 
             <LabelList dataKey={itemValue} position="right" style={{ fill: "black" }} />
        </Bar>);
        return bars;
    });

    return (bars);
}

